import { useParams, useNavigate } from "react-router-dom";
import { Download, Sparkles } from "lucide-react";
import { Logo } from "../components/Logo";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ClipShare() {
  const { id } = useParams();
  const navigate = useNavigate();
  const src = `${BACKEND}/api/video/file/${id}`;

  return (
    <div className="min-h-screen bg-[#0B0D12] text-[#F8FAFC] flex flex-col">
      <header className="border-b border-[#262C3A] px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate("/")} className="flex items-center gap-2" data-testid="share-home">
            <Logo className="h-7 w-auto" />
          </button>
          <span className="ml-auto text-xs font-mono uppercase bg-[#FF5500]/15 text-[#FF5500] px-2 py-0.5 rounded-full">Clip IA</span>
        </div>
      </header>

      <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-8 flex flex-col items-center">
        <h1 className="text-2xl sm:text-3xl font-black tracking-tight text-center mb-1">Un clip créé avec TUBMIX</h1>
        <p className="text-[#94A3B8] text-sm text-center mb-6">Généré par IA à partir d'une photo et d'une musique.</p>

        <div className="w-full bg-[#131722] border border-[#262C3A] rounded-2xl p-3 sm:p-4">
          <video src={src} controls autoPlay playsInline className="w-full rounded-xl border border-[#262C3A] bg-black" data-testid="shared-video" />
          <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
            <a href={src} download="clip-tubmix.mp4" data-testid="shared-download"
              className="inline-flex items-center gap-2 bg-[#10B981]/15 hover:bg-[#10B981]/25 text-[#10B981] rounded-xl px-5 py-3 font-semibold transition-colors">
              <Download className="h-5 w-5" /> Télécharger le clip
            </a>
            <button onClick={() => navigate("/studio")} data-testid="shared-create-cta"
              className="inline-flex items-center gap-2 bg-[#FF5500] hover:bg-[#e64d00] text-white rounded-xl px-5 py-3 font-bold transition-colors">
              <Sparkles className="h-5 w-5" /> Créer mon clip
            </button>
          </div>
        </div>

        <p className="text-[11px] text-[#475569] mt-6 text-center">
          TUBMIX · Créateur de clip musical IA — une photo, une musique, un clip.
        </p>
      </main>
    </div>
  );
}
